import moment from "moment";
import momentTimeZone from "moment-timezone";

// Format for moment.js - March 10, 2020
export const dateInputFormat = "MMMM D, YYYY";

class FormatDateUtil {
  getTimezone = () => {
    return momentTimeZone.tz.guess();
  };

  utcToLocal = date => {
    return moment.utc(date).local();
  };

  localToUtc = date => {
    return moment(date).utc();
  };

  getTimezoneAbbr = () => {
    return momentTimeZone.tz
      .zone(momentTimeZone.tz.guess())
      .abbr(moment().utc());
  };

  getTimezoneLong = () => {
    const timeZone = momentTimeZone.tz.guess();
    const timeZoneAbbr = momentTimeZone.tz.zone(timeZone).abbr(moment().utc());
    return `${timeZoneAbbr} - ${timeZone}`;
  };

  formatUtcToLocal = (date, pattern = dateInputFormat) => {
    if (date === "") return "--- --- ---";
    return moment
      .utc(date)
      .local()
      .format(pattern);
  };

  isValidDate = arg => {
    // moment.isDate(obj);
    if (!arg) return false;
    return moment(arg).isValid();
  };
}

export default new FormatDateUtil();
